import { closeModalAction } from "../../../../app/appActions";
import { connect } from "react-redux";
import { ModalsCloseButtonStyled } from "./styled/ModalsCloseButtonStyled";
import BinIcon from "../../../../components/icon/Icon";

function ModalsCloseButton(props) {
    const {closeModalAction} = props;

    return <ModalsCloseButtonStyled onClick={closeModalAction}>
            <BinIcon name="IcXMark"/>
        </ModalsCloseButtonStyled>
}

const mapDispatchToProps = {
    closeModalAction,
}

export default connect(null, mapDispatchToProps)(ModalsCloseButton);
